export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image2-088865fd7a253a0570ec2fbb6de0cde3.png";